import { Component, OnInit } from '@angular/core';
import { AuthorisedSideNavService } from '../../../layout/authorised/services/authorised-side-nav.service';
import { FormBuilder,FormControl, Validators ,FormGroup,FormArray } from '@angular/forms';
import {MatCalendar} from '@angular/material/datepicker';
import {DateAdapter, MAT_DATE_FORMATS, MatDateFormats} from '@angular/material/core';
import { ClientServiceService } from "../../../shared/client-service.service";
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit 
{
  loggeduser: any;
  clientData: any[] = [];
  pData: any[] = [];
  clientemail:string;
  clientDetails:any;
  product_types=['select'];
  product_desc=[''];
  total_monthly:number=0;
  total_yearly:number=0;
  total_grand:number=0;
  is_order_submitted=false;
  is_order_loading=false;
  is_order_responded=false;
  is_order_responded_success=false;
  is_order_responded_failed=false;

  editId:string;
  orderHeading: string = 'Create Order';

  items: FormArray;

  orderForm = new FormGroup({
    order_number: new FormControl('', Validators.required),
    name: new FormControl('', Validators.required),
    company_name: new FormControl('', Validators.required),
    billing_address: new FormControl(''),
    billing_city: new FormControl(''),
    state: new FormControl(''),
    country: new FormControl('USA'),
    zipcode: new FormControl(''),
    telephone: new FormControl('',  [
      Validators.required,
      Validators.minLength(10)
    ]),
    email: new FormControl('',  [
      Validators.required
    ]),
    url: new FormControl('', Validators.required),
    created_date: new FormControl('', Validators.required),
    seo_consultant: new FormControl('', Validators.required),
    seo_consultant_email: new FormControl('',  [
      Validators.required,
      Validators.email
      ]),
    dialer: new FormControl(''),

    tot_month_pay: new FormControl('0', Validators.required),
    tot_one_pay: new FormControl('0', Validators.required),
    grand_total: new FormControl('0', Validators.required),
    term: new FormControl('Month to Month', Validators.required),
    payment_mode_ids: new FormControl('2', Validators.required),
    note: new FormControl(''),
    items: new FormArray([this.createItem()])
  });

  constructor(
    public sideNavService: AuthorisedSideNavService,
    private formBuilder: FormBuilder, 
    public restApi: ClientServiceService, 
    private route: ActivatedRoute) 
  { }

  ngOnInit(): void 
  {
   this.items = this.orderForm.get('items') as FormArray;
    this.loggeduser=JSON.parse(localStorage.getItem('seocurrentUser'));
    this.setsalesman();
    this.restApi.getProducts().subscribe(data =>
    {
      this.pData=data.products;
    });

    this.restApi.getOrderNum().subscribe(data =>{
      this.orderForm.controls['order_number'].setValue(data.order_number);
    });

    this.route.paramMap.subscribe(params => 
    {
      if (params.get('id'))
      {
        this.editId=params.get('id');
        this.orderHeading = 'Edit Order';
        this.restApi.getEditOrderData(this.editId).subscribe(data =>
        {
          if(data.found=="true")
          {
            console.log(data);
            this.setCustomerInfo(data.customerInfo);
            this.setProductInfo(data.orderdetails);
            this.setPaymentInfo(data.customerInfo);
          }
        });
      }
    });
    
    this.calculate_total();
  }

  setCustomerInfo(clientDetails)
  {
    this.orderForm.controls['name'].setValue(clientDetails.name);
    this.orderForm.controls['company_name'].setValue(clientDetails.company_name);
    this.orderForm.controls['billing_address'].setValue(clientDetails.billing_address);
    this.orderForm.controls['billing_city'].setValue(clientDetails.billing_city);
    this.orderForm.controls['state'].setValue(clientDetails.state);
    this.orderForm.controls['country'].setValue(clientDetails.country);
    this.orderForm.controls['zipcode'].setValue(clientDetails.zipcode);
    this.orderForm.controls['email'].setValue(clientDetails.email);
    this.orderForm.controls['url'].setValue(clientDetails.url);
    this.orderForm.controls['created_date'].setValue(clientDetails.date);
    this.orderForm.controls['telephone'].setValue(clientDetails.telephone);
    this.orderForm.controls['dialer'].setValue(clientDetails.dialer);
  }

  setProductInfo(productArray)
  {
    this.items = this.orderForm.get('items') as FormArray;
    this.items.removeAt(0);
    this.product_types.splice(0, 1); 
    this.product_desc.splice(0, 1); 

    for(let i=0; i<productArray.length; i++)
    {
        let product;
        if(productArray[i].product_id > 0)
        {
          this.product_types.push('select');
          product = productArray[i].product_id;
        }
        else
        {
          this.product_types.push('text');
          product = productArray[i].product_name;
        }

        this.product_desc.push(productArray[i].plist);

        let item = new FormGroup({
          'name': new FormControl(product),
          'quantity': new FormControl(productArray[i].quantity),
          'price': new FormControl(productArray[i].product_price),
          'time_type': new FormControl(productArray[i].payment_type)
        });

        this.items.push(item);
    }

    this.calculate_total();

  }

  setPaymentInfo(clientDetails)
  {
    this.orderForm.controls['term'].setValue(clientDetails.term);
    this.orderForm.controls['payment_mode_ids'].setValue(clientDetails.payment_mode_ids);
    this.orderForm.controls['note'].setValue(clientDetails.note);
  }

  setsalesman()
  {
    this.orderForm.controls['seo_consultant'].setValue(this.loggeduser.firstname+" "+this.loggeduser.lastname);
    this.orderForm.controls['seo_consultant_email'].setValue(this.loggeduser.email);
  }

  ordersubmit()
  {
    this.is_order_submitted=true;
    if (this.orderForm.valid && this.items.length) 
    {
      this.is_order_loading=true;
      var self=this;

      if (this.editId)
      {
        this.restApi.updateOrder(this.orderForm.value, this.editId).subscribe( data =>
        {
          self.is_order_responded=true;
          self.is_order_responded_success=true;
          self.is_order_loading=false;
          document.querySelector('.breadcrumb').scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
      else
      {
        this.restApi.SubmitForm(this.orderForm.value).subscribe( data =>
        {
          self.is_order_responded=true;
          self.is_order_responded_success=true;
          self.is_order_loading=false;
          document.querySelector('.breadcrumb').scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    }
  }

  createItem(): FormGroup 
  {
    return new FormGroup({
      name: new FormControl('', Validators.required),
      quantity: new FormControl('1', Validators.required),
      price: new FormControl('', Validators.required),
      time_type:new FormControl('Monthly', Validators.required)
    });
  }

  addItem(): void 
  {
    this.items = this.orderForm.get('items') as FormArray;
    this.product_types.push('select');
    this.product_desc.push('');
    this.items.push(this.createItem());
  }

  addCustomItem(): void 
  {
    this.items = this.orderForm.get('items') as FormArray;
    this.product_types.push('text');
    this.product_desc.push('');
    this.items.push(this.createItem());
  }
  
  removeItem(index: number) 
  {
    this.items.removeAt(index);
    this.product_types.splice(index, 1); 
    this.product_desc.splice(index, 1); 
    this.calculate_total();
  }

  increment(index: number) 
  {
    console.log(this.orderForm.get('items'))
    var counter:number=this.orderForm.get('items')['controls'][index].get('quantity').value;
    counter++;
    this.orderForm.get('items')['controls'][index].get('quantity').setValue(counter);
    this.calculate_total();
  }

  decrement(index: number) 
  {
    var counter:number=this.orderForm.get('items')['controls'][index].get('quantity').value;
    if(counter==1)
      return false;
    counter--;
    this.orderForm.get('items')['controls'][index].get('quantity').setValue(counter);
    this.calculate_total();
  }
  
  changeProduct(e) 
  {
    console.log(e.target);
    var elementid=e.target.id.replace("product_desc_","");

    this.restApi.getProductDetails(e.target.value).subscribe(data =>{
      if(data.found=="true")
      {
        var innertext="<ul class='pinfo'>";
        for(var i = 0; i < data.products.length; i++)
        {
          innertext+="<li>"+data.products[i].feature_name+"</li>";
        }
        innertext+="</ul>";
        this.product_desc[elementid]=innertext;
      }
      else
      {
        this.product_desc[elementid]="";
      }
    })
  }
  calculate_total()
  {
    console.log('checking total');
    this.total_monthly=0;
    this.total_yearly=0;
    this.total_grand=0;
    for(var j=0; j<this.orderForm.get('items')['controls'].length;j++)
    {
      var each_item=this.orderForm.get('items')['controls'][j];
      var q=each_item.get('quantity').value;
      var p=each_item.get('price').value;
      var subtotal=q*p;
      if(each_item.get('price').valid)
      {
        if(each_item.get('time_type').value=="One Time")
        {
          this.total_yearly+=subtotal;
        }
        else if(each_item.get('time_type').value=="Monthly")
        {

          this.total_monthly+=subtotal;
        }
        this.total_grand+=subtotal;
      }
    }
    console.log(this.total_monthly+"---"+this.total_yearly+"---"+this.total_grand);
    this.orderForm.controls['tot_month_pay'].setValue(this.total_monthly);
    this.orderForm.controls['tot_one_pay'].setValue(this.total_yearly);
    this.orderForm.controls['grand_total'].setValue(this.total_grand);
  }
}